module.exports = __webpack_public_path__ + "img/sustainabilityPlatinum@2x.4db3685.jpg";